export default {"src":"/_next/static/media/add-to-cart-popover.19358406.gif","height":1080,"width":1920,"blurWidth":0,"blurHeight":0};